import React, { useState, useRef, useEffect } from "react";
import SunEditor from "suneditor-react";
import ImageManagerModal from "./admin/ImageManagerModal";

const TextEditor = ({
  value = "",
  onChange,
  name,
  canUpdate = true,
  importCustomInsertImage = false,
  minHeight = "500px",
}) => {
  const [content, setContent] = useState(value);
  const editorRef = useRef(null);
  const [selectedMultiMedia, setSelectedMultiMedia] = useState([]);
  const [isModalImageManagerOpen, setIsModalImageManagerOpen] = useState(false);

  useEffect(() => {
    setContent(value);
  }, [value]);

  const handleChange = (editorContent) => {
    if (onChange) {
      onChange({ name, value: editorContent });
    }
  };

  const handleCloseImageManagerModal = () => {
    setSelectedMultiMedia([]);
    setIsModalImageManagerOpen(false);
  };

  const handleOpenImageManagerModal = () => {
    setIsModalImageManagerOpen(true);
  };

  const handlePressImage = (media) => {
    if (selectedMultiMedia.map((e) => e.id).includes(media.id)) {
      setSelectedMultiMedia((prev) => [
        ...prev.filter((m) => m.id != media.id),
      ]);
    } else {
      setSelectedMultiMedia((prev) => [media, ...prev]);
    }
  };

  const insertMultiImage = () => {
    selectedMultiMedia.forEach((img) => {
      if (img.url) {
        const imageHTML = `<img src="${img.url}" alt="inserted image" />`;
        editorRef.current?.insertHTML(imageHTML);
      }
    });
    setSelectedMultiMedia([]);
    handleCloseImageManagerModal();
  };

  const insertImageFormUrl = (imgUrl) => {
    if (imgUrl) {
      const imageHTML = `<img src="${imgUrl}" alt="inserted image" />`;
      editorRef.current?.insertHTML(imageHTML);
    }
  };

  const getSunEditorInstance = (sunEditor) => {
    editorRef.current = sunEditor;
    setTimeout(() => {
      const editorDom = editorRef.current.core.context.element.wysiwyg;
      editorDom.setAttribute("contenteditable", canUpdate ? "true" : "false");

      const toolbar = editorRef.current.core.context.element.toolbar;
      if (!toolbar) return;

      if (!canUpdate) {
        toolbar.classList.add("pointer-events-none");
      }

      const imageBtn = toolbar.querySelector(
        'button[data-command="image"][aria-label="Image"]',
      );

      if (imageBtn) {
        // imageBtn.innerHTML = "Thêm ảnh";
        // imageBtn.style.backgroundColor = canUpdate ? "#27ca99ff" : "#B9BDBCFF";
        // imageBtn.style.color = "white";
        // imageBtn.style.border = `2px solid ${
        //   canUpdate ? "#27ca99ff" : "#B9BDBCFF"
        // }`;
        // imageBtn.style.borderRadius = "8px";
        // imageBtn.style.padding = "8px";
        // imageBtn.style.cursor = "pointer";
        // imageBtn.style.fontSize = "14px";
        // imageBtn.style.fontWeight = "bold";
        // imageBtn.style.height = "34px";
        // imageBtn.style.width = "100px";
        // imageBtn.style.display = "flex";
        // imageBtn.style.justifyContent = "center";
        // imageBtn.style.alignItems = "center";

        imageBtn.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          handleOpenImageManagerModal();
        };
      }
    }, 200);
  };

  const buttonList = [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["removeFormat"],
    "/",
    ["fontColor", "hiliteColor"],
    ["outdent", "indent"],
    ["align", "horizontalRule", "list", "table"],
    importCustomInsertImage ? ["link", "image", "video"] : ["link", "video"],
    ["fullScreen", "showBlocks", "codeView"],
    ["preview", "print"],
  ];

  return (
    <div>
      <div className="editor-wrapper z-[9999]">
        <SunEditor
          getSunEditorInstance={getSunEditorInstance}
          setContents={content}
          onChange={handleChange}
          setOptions={{
            buttonList,
            minHeight,
            height: "auto",
            placeholder: "Nhập nội dung...",
            disable: !canUpdate,
            defaultStyle: `
              font-size: 16px;
              line-height: 1.7;
              min-height: 500px;
            `,
          }}
        />
      </div>

      {isModalImageManagerOpen && (
        <ImageManagerModal
          onClose={handleCloseImageManagerModal}
          onPress={handlePressImage}
          multiImage={true}
          selectedMultiMedia={selectedMultiMedia}
          onInsertImage={insertMultiImage}
          onInsertImageFormUrl={insertImageFormUrl}
        />
      )}

      {/* <style jsx>{`
        .editor-wrapper {
          position: relative;
        }
        .custom-image-btn {
          position: absolute;
          top: 5px;
          right: 10px;
          z-index: 10;
          background-color: ${canUpdate ? "#27ca99ff" : "#B9BDBCFF"};
          color: white;
          border: 2px solid ${canUpdate ? "#27ca99ff" : "#B9BDBCFF"};
          border-radius: 8px;
          padding: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: bold;
          height: 34px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      `}</style> */}
    </div>
  );
};

export default TextEditor;
